import type { TOC } from '@ember/component/template-only';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface GeneralTablesCellsTdWithIconWithTooltipSignature {
  Args: {
    cellData: {
      tooltipContent?: string;
    };
    value: string;
  };
}

const GeneralTablesCellsTdWithIconWithTooltip = <template>
  <div class="flex items-center gap-100">
    {{@value}}
    {{#if @cellData.tooltipContent}}
      <GeneralIconWithTooltip @tooltipContent={{@cellData.tooltipContent}} />
    {{/if}}
  </div>
</template> satisfies TOC<GeneralTablesCellsTdWithIconWithTooltipSignature>;

export default GeneralTablesCellsTdWithIconWithTooltip;
